import { useAuth } from "@/context/AuthContext";
import { DelegationForm } from "@/components/DelegationForm";
import { CalendarOff } from "lucide-react";

export default function MyAbsencePage() {
  const { user } = useAuth();
  return (
    <div data-testid="my-absence-page">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Mon absence</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Programmez une délégation pendant votre absence : les nouveaux tickets qui vous seraient attribués
          seront automatiquement redirigés vers votre remplaçant, puis reviendront vers vous à la date de fin.
        </p>
      </div>
      <div className="max-w-2xl rounded-sm border border-border bg-card p-6">
        <div className="mb-4 flex items-center gap-2">
          <CalendarOff className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-medium">Délégation de mes tickets</h2>
        </div>
        {user?.id && <DelegationForm userId={user.id} />}
      </div>
    </div>
  );
}
